import { FC } from 'react'
import { useKeymaps } from '@remirror/react'

interface Props {
  onKeyPressEnter?: () => void
}

const EnterBinding: FC<Props> = ({ onKeyPressEnter }) => {
  useKeymaps({
    'Mod-Enter': () => {
      if (onKeyPressEnter) {
        onKeyPressEnter?.()
        return true
      }
      return false
    }
  })

  return null
}

export default EnterBinding
